export const FORM_IDS = {
	HANDYMAN_CHECKLIST: "2",
	QC_CHECKLIST: "4",
	PRE_WALK_CHECKLIST: "6",
	PROPERTY_CONDITION_ASSESSMENT: "7",
};
